import { render, staticRenderFns } from "./modalManageModuleAccess.vue?vue&type=template&id=62fd7921&"
import script from "./modalManageModuleAccess.vue?vue&type=script&lang=js&"
export * from "./modalManageModuleAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports